<template>
  <div class="container">
    <div class="contract">
      <h2 class="text-center magb20">
        Hướng dẫn xóa tài khoản và dữ liệu liên quan đến người dùng
      </h2>
      <h2 class="text-center magb20">MY NEXTPAY</h2>
      <div class="guide">
        <div id="accordion" class="accordion" v-viewer>
          <div class="card">
            <div class="card-header">
              <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                Bước 1: Truy cập ứng dụng MY NEXTPAY trên thiết bị di động
              </a>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                Bước 2: Đăng nhập vào ứng dụng
              </a>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                Bước 3: Vào trang "Thông tin tài khoản", chọn "Xóa tài khoản"
              </a>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                Bước 4: Xác nhận Xóa tài khoản và nhận SMS chứa OTP tới số điện thoại
              </a>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                Bước 5: Nhập OTP và hoàn tất quá trình xóa tài khoản
              </a>
            </div>
          </div>
        </div>
      </div>
      <h4 class="text-center magb20 mt-2">
        Sau khi xóa tài khoản, các thông tin cá nhân của người dùng sẽ bị xóa.
      </h4>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        style: {
          width: '100%',
        },
      }
    },
    methods: {},
    components: {},
  }
</script>

<style scoped src="@/assets/css/style_hdsd.css"></style>

<style scoped src="@/assets/css/bootstrap4.3.1.min.css"></style>

<style scoped>
  .container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
</style>
